/**
 * 创建人：zll
 * 时间：2020-10-28
 * 描述：指导型工具提示组件封装（向左、向右、向上、向下）
 * 使用说明: 参考 sw-tooltip 配置应用说明文档   
 * 更新记录: 
 * 
 */
import { Component, OnInit, Input, ContentChild, TemplateRef, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef  } from '@angular/core';
declare var $: any;

@Component({
  selector: 'sw-tooltip',
  templateUrl: './sw-tooltip.component.html',
  styleUrls: ['./sw-tooltip.component.css']
})
export class SwTooltipComponent implements OnInit {
  /**
   * 指导型工具提示的id
   * @ignore
   */
  idt: string;
  /**
  * 指导型工具提示方向 默认top
  * left 左侧提示框/右侧箭头
  * right 右侧提示框/左侧箭头
  * top 顶部提示框/底部箭头
  * bottom 底部提示框/顶部箭头
  * @ignore 
  */
 @Input() position: string = 'top'

 /**
  * 鼠标移上时 位置方向
  */
 hoverPosition: string = ""
  /**
  * 指导型工具提示的宽度 默认为120px
  * height高度为auto
  * @ignore 
  */
 @Input() width: string = '120px'   
 
   /**
  *图标颜色
  */
 @Input() iconColor: string = '#999999'  
 /**
  * 是否出现在模态框內（解决在模态框內，因为父组件有transform,影响fixed对浏览器窗口固定定位功能）
  * @ignore 
  */
 @Input() isModal: boolean = false   
  /**
  * 输入当前模态框属性，用于获取当前模态框的元素id,根据元素id获取当前模态框盒子相对于浏览器窗口的top值，和left值 ==》在isModal为true的条件下
  * (用于解决在模态框中，提示框定位相对于模态框定位，而非浏览器定位问题)
  * @ignore 
  */
 @Input() modal: any   

  constructor(private el: ElementRef,) { }

  ngOnInit() {
    //初始化
    this.hoverPosition = this.position
    this.idt = "tooltip" + Math.random().toString().split(".")[1];
  }

   //鼠标移入事件 创建组件
   mouseover(event) {
    let X = 0;
    let Y = 0;
    //若在模态框內
     if(this.isModal){
       //获取该模态框相对浏览器窗口的top值
       Y = $('#'+this.modal['ids']+' .modal-dialog').offset().top;
       //获取该模态框相对浏览器窗口的left值
       X = $('#'+this.modal['ids']+' .modal-dialog').offset().left;
     }
      this.hoverPosition = this.position;
      event.stopPropagation();
      $('#'+this.idt).css({'visibility':'visible',"opacity":'1'})
      //debugger
      //当前组件的位置信息
      let elPosition = this.el.nativeElement.querySelector('#'+this.idt).parentNode.getBoundingClientRect()
      //浏览器的宽度
      let windowWidth = $(window).width()
      //浏览器的高度
      let windowHeight = $(window).height()
      //消息内容框的总宽度
      let tooltiptextWidth = $('#'+this.idt).outerWidth()
      //消息内容框的总高度
      let tooltiptexHeight = $('#'+this.idt).outerHeight()
      //当前组件初始位置方向
     if(this.hoverPosition == 'left'){
        //判断当前组件盒子tooltip的(left-4)值和tooltiptext盒子的宽度大小 大于tooltiptext盒子的宽度 position的值为left 反之为right
        let leftWidthCha = elPosition.left -4 - tooltiptextWidth
        if(leftWidthCha <= 0){
          this.hoverPosition = 'right'
        }
     }else if(this.hoverPosition == 'right'){
        //判断当前浏览器的宽度-当前组件盒子tooltip的(right+4)和tooltiptext盒子的宽度大小 大于tooltiptext盒子的宽度 position的值为right 反之为left
        let rightWidthCha =windowWidth - (elPosition.right+4) - tooltiptextWidth
        if(rightWidthCha <= 0){
          this.hoverPosition = 'left'
        }
     }else if(this.hoverPosition == 'top'){
        //判断当前组件盒子tooltip的(top-2-4)和tooltiptext盒子的高度大小 大于tooltiptext盒子的高度 position的值为top 反之为bottom
        let topHeightCha =elPosition.top-2-4-tooltiptexHeight
        if(topHeightCha <= 0){
          this.hoverPosition = 'bottom'
        }
     }else if(this.hoverPosition == 'bottom'){
        //判断当浏览器的高度-前组件盒子tooltip的(bottom+4)和tooltiptext盒子的高度大小 大于tooltiptext盒子的高度 position的值为bottom 反之为top
        let bottomHeightCha =windowHeight - (elPosition.bottom+4) - tooltiptexHeight 
        if(bottomHeightCha <= 0){
          this.hoverPosition = 'top'
        }
     }

     switch(this.hoverPosition){
       case 'right':
            this.el.nativeElement.querySelector('#'+this.idt).style.left = elPosition.right+4 - X + 'px'
            this.el.nativeElement.querySelector('#'+this.idt).style.top = (elPosition.top-tooltiptexHeight/2+elPosition.height/2) - Y + 'px'
        break;
        case 'left':
            this.el.nativeElement.querySelector('#'+this.idt).style.left = (elPosition.left-tooltiptextWidth-4) - X + 'px'
            this.el.nativeElement.querySelector('#'+this.idt).style.top = (elPosition.top-tooltiptexHeight/2+elPosition.height/2) - Y + 'px'
        break;
        case 'top':
            this.el.nativeElement.querySelector('#'+this.idt).style.left = (elPosition.left-tooltiptextWidth/2+elPosition.width/2) - X + 'px'
            this.el.nativeElement.querySelector('#'+this.idt).style.top = (elPosition.top-tooltiptexHeight-2-4) - Y + 'px'
        break;
        case 'bottom':
            this.el.nativeElement.querySelector('#'+this.idt).style.left = (elPosition.left-tooltiptextWidth/2+elPosition.width/2) - X + 'px'
            this.el.nativeElement.querySelector('#'+this.idt).style.top = elPosition.bottom+4 - Y + 'px'
        break;
       default:
            this.el.nativeElement.querySelector('#'+this.idt).style.left = elPosition.right - X + 'px'
            this.el.nativeElement.querySelector('#'+this.idt).style.top = (elPosition.top-tooltiptexHeight/2+elPosition.height/2)-Y + 'px'
        break;
     }

  }
  //鼠标滚动事件 隐藏信息内容框
  mousewheel(event) {
    event.stopPropagation();
      //$('#'+this.idt).hide()
      $('#'+this.idt).css({'visibility':'hidden',"opacity":'0'})
 
  }

  //鼠标移出事件 隐藏信息内容框
  mouseout(event) {
    event.stopPropagation();
    $('#'+this.idt).css({'visibility':'hidden',"opacity":'0'})
      //$('#'+this.idt).hide()
  }
  //防止tips触发任何事件，只是提示即可，阻止事件冒泡
  stopClickPropagation(event) {
    event.stopPropagation();
  }
}

